export * from 'server/models/Location';


// WEBPACK FOOTER //
// ./data/models/Location.ts